import { Row, Section } from '../ExecutiveSummaryGenericTable/types';
import {
    BlockResolver, CellDescriptor, RowDescriptor, RowLabel, SectionDescriptor, SectionHeaders,
} from './types';

const buildColumns = (columns: readonly string[], headers: SectionHeaders = 'labels'): string[] | undefined => {
    if (headers === 'none') return undefined;
    return headers === 'empty' ? [] : [...columns];
};

const resolveLabel = <M extends string>(label: RowLabel<M>, resolver: BlockResolver<M>): string => {
    if (typeof label === 'string') return label;
    const resolved = resolver[label.metric]().value;
    return typeof resolved === 'string' && resolved ? resolved : label.fallback;
};

const buildRow = <M extends string>(row: RowDescriptor<M, readonly string[]>, resolver: BlockResolver<M>): Row => {
    const cells: readonly CellDescriptor<M>[] = row.cells;
    const values = cells.map(cell => ('fixed' in cell
        ? cell.fixed
        : { ...resolver[cell.metric](), isNegative: cell.isNegative }));

    return {
        id: row.id,
        label: resolveLabel(row.label, resolver),
        className: row.className,
        tooltip: row.tooltip,
        values,
    };
};

export const buildSections = <M extends string>(
    layout: SectionDescriptor<M, readonly string[]>[],
    resolver: BlockResolver<M>,
): Section[] => (
        layout.map(section => ({
            id: section.id,
            title: section.title,
            columns: buildColumns(section.columns, section.headers),
            isTotal: section.isTotal,
            rows: section.rows.map(row => buildRow(row, resolver)),
        }))
    );
